/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselRequestMoreImages_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_viewer">;
    readonly " $refType": "PdpRespHeroCarouselRequestMoreImages_viewer";
};
export type PdpRespHeroCarouselRequestMoreImages_viewer$data = PdpRespHeroCarouselRequestMoreImages_viewer;
export type PdpRespHeroCarouselRequestMoreImages_viewer$key = {
    readonly " $data"?: PdpRespHeroCarouselRequestMoreImages_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarouselRequestMoreImages_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '01d4488d55e8868c45d65ad6d7f2c95e';
export default node;
